module.exports = __webpack_public_path__ + "static/media/81+4Spiow3L._SL1500_.95b91255.jpg";